import React, { useMemo } from 'react';
import { scroller } from 'react-scroll';
import {
  Box,
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerBody,
  Image,
  Text,
  Divider,
  DrawerFooter,
  // hooks
  useDisclosure,
  useToast,
} from '@chakra-ui/react';
import { MdClose, MdMenu } from 'react-icons/md';

import useInvitation from '@/hooks/useInvitation';
import useIsDesktopView from '@hooks/useIsDesktopView';
import useLang from '@/hooks/useLang';
import { THE_BRIDE } from '@/constants';
import { BG_SECONDARY_LIGHT } from '@/constants/colors';

import useMenuData from './hooks/useMenuData';
import txt from './locales';
import { SPH_LOGO } from '@/constants/sph';

function Navigation() {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { isDesktopView } = useIsDesktopView();

  const toast = useToast();
  const lang = useLang();
  const menuData = useMenuData();

  const btnRef = React.useRef();
  const isInvitation = useInvitation();

  const filteredMenuData = useMemo(
    () =>
      menuData.filter((i) => {
        if (isInvitation) return true;
        if (!i.invitationOnly) return true;
        return false;
      }),
    [],
  );

  const onClickMenu = (ELEMENT_CONTENT_ID, offset) => {
    try {
      onClose();
      // const element = document.getElementById(ELEMENT_CONTENT_ID).offsetTop;
      scroller.scrollTo(ELEMENT_CONTENT_ID, {
        duration: 1500,
        delay: 100,
        smooth: true,
        offset,
      });
    } catch {
      toast({
        title: 'Oops!',
        description: txt.menuNotFound[lang],
        status: 'error',
        duration: 9000,
        isClosable: true,
      });
    }
  };

  return (
    <>
      <IconButton
        colorScheme="blackAlpha"
        ref={btnRef}
        borderRadius="50%"
        position="fixed"
        zIndex="999"
        bottom="12px"
        left="12px"
        size="sm"
        boxShadow="xl"
        bgColor={BG_SECONDARY_LIGHT}
        onClick={isOpen ? onClose : onOpen}
        icon={isOpen ? <MdClose color="white" /> : <MdMenu color="white" />}
      />
      <Drawer size="xs" placement="right" onClose={onClose} isOpen={isOpen}>
        <DrawerOverlay />
        <DrawerContent
          maxWidth={isDesktopView ? '30%' : '75%'}
          bgColor="bgAlternative"
          padding="24px 16px"
        >
          <DrawerBody textAlign="right">
            <Image src={SPH_LOGO} height="70px" position="absolute" top="20px" right="38px" />
            <Box marginTop="90px">
              {filteredMenuData.map((i) => {
                return (
                  <div key={i.value}>
                    <Text
                      marginTop="16px"
                      textTransform="uppercase"
                      color="white"
                      letterSpacing="3px"
                      cursor="pointer"
                      onClick={() => onClickMenu(i.value, i.offset)}
                    >
                      {i.name}
                    </Text>
                    <Divider width="100%" marginTop="8px" borderColor="whiteAlpha.500" />
                  </div>
                );
              })}
            </Box>
          </DrawerBody>
          <DrawerFooter>
            <Box textAlign="center" fontSize="xs">
              <Text color="white">Created with Love by Invitato</Text>
              <Text color="white">{`${new Date().getFullYear()} ${THE_BRIDE}. All Rights Reserved`}</Text>
            </Box>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}

export default Navigation;
